import dynamic from "next/dynamic";

export const Footer = dynamic(() => import("./component"));
